import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { LanguageType } from 'global.interfaces';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import { ErrorLabel } from '../errorLabel';
import { Attributes } from '../formField.interface';
import { HintMessage } from '../hintMessage';

interface IProps {
  name: string;
  title?: string;
  transTitle?: JSX.Element;
  type: string;
  attributes?: Attributes;
  valid: boolean;
  validationMessage?: string;
  hintMessage?: string;
  value?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  labelClassName?: string;
}

const Checkbox = observer((props: IProps) => {
  const {
    name,
    title,
    transTitle,
    type,
    attributes,
    valid,
    validationMessage,
    hintMessage,
    value,
    onChange,
    className = '',
    labelClassName = '',
  } = props;

  const { i18n } = useTranslation();

  const currentLanguage = i18n.language as LanguageType;
  const labelHint = className === 'longLabel' ? title : undefined;

  const { accountStore } = useMobxStore();
  const { brokerParams } = accountStore.generalSettings;

  const checkboxLabel = transTitle ? (
    <span className="form__checkbox-label-text">{transTitle}</span>
  ) : (
    <span className={`form__checkbox-label-text ${labelClassName}`}>
      {title &&
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        i18n.t(title as any, {
          brokerName: brokerParams[currentLanguage]?.brokerName,
          clientSupportEmail: brokerParams[currentLanguage]?.clientSupportEmail,
        })}
    </span>
  );

  return (
    <div
      key={name}
      className={cn(`form__checkbox ${className}`, { disabled: attributes?.disabled })}
      data-fieldname={name}
      title={labelHint}>
      <label className="form__checkbox-label-wrapper">
        <input
          className={cn('form__checkbox-input', { invalid: !valid })}
          type={type}
          name={name}
          checked={value}
          onChange={onChange}
          disabled={attributes?.disabled}
        />
        <span className={cn('form__checkbox-label', { 'form__checkbox-label_error': !valid })} />
      </label>
      {checkboxLabel}
      {!valid && validationMessage && <ErrorLabel message={validationMessage} />}
      {hintMessage && <HintMessage valid={valid} message={hintMessage} />}
    </div>
  );
});

export default Checkbox;
